import React from 'react';
import TemplatePageLeftContent from "../template_page/template_page_left_content/template_page_left_content";
import { CoursePageData } from "./course_page";
import C26TCourseLeftItem from "../../left_items/c26t_corso_left_item/c26t_corso_left_item";
import C88BoxTitleImageCTA from '../../left_items/c88_box_title_image_cta/c88_box_title_image_cta';
import C90ContactForm from '../../left_items/c90_contact_form/c90_contact_form';

const FILTER_TERMS_GRADUATE = "graduate";
const FILTER_TERMS_UNDERGRADUATE = "undergraduate";
const FILTER_TERMS_NETWORK = "network";
const FILTER_TERMS_DOUBLE = "double degree";
const FILTER_TERMS_STRUCTURED = "structured partnership";

class CoursePageLeftContent extends TemplatePageLeftContent<CoursePageData> {

    headlines(page: CoursePageData): React.ReactElement | React.ReactNodeArray | React.ReactPortal | undefined {
        return undefined;
    }

    beforeLeftComponentsList(page: CoursePageData): React.ReactElement | React.ReactNodeArray | React.ReactPortal | undefined {
        // The left item Course Summary needs more properties (the course attributes) to render properly

        if (!page.hasOwnProperty('left_column') || !page.left_column){
            Object.assign(page, {'left_column': [{'type': 'contact_form', 'title': page.title}]});
        }

        if (page.left_column) {
            
            if ((page.label_dipartimento && (page.label_dipartimento.toLowerCase().includes(FILTER_TERMS_GRADUATE) || page.label_dipartimento.toLowerCase().includes(FILTER_TERMS_UNDERGRADUATE))) &&
                (page.course_type && (!page.course_type.toLowerCase().includes(FILTER_TERMS_NETWORK) || !page.course_type.toLowerCase().includes(FILTER_TERMS_DOUBLE) || !page.course_type.toLowerCase().includes(FILTER_TERMS_STRUCTURED))) &&
                (page.left_column?.filter(e => e.type === 'contact_form').length <= 0)
                ) {
                    page.left_column.unshift({'type': 'contact_form', 'title': page.title}); 
                  }
            
            return page.left_column
                .filter(item => 
                                item.type === C88BoxTitleImageCTA.ID ||
                                item.type === C26TCourseLeftItem.ID ||
                                item.type === C90ContactForm.ID
                        )
                .map((item, index) =>
                    (item.type === C88BoxTitleImageCTA.ID) ?
                        <div>
                            <C88BoxTitleImageCTA key={"left-item-course-summary-" + index} url={item.data} id={item.type}
                                language={this.props.language} layoutColumns={this.props.layoutColumns}
                                courseAttributes={{
                                    course_type: page.course_type,
                                    label_dipartimento: page.label_dipartimento,
                                    color_dipartimento: page.color_dipartimento
                                }} />
                        </div>
                        :
                        (item.type === C26TCourseLeftItem.ID) ?
                            <div>
                                <C26TCourseLeftItem key={"left-item-course-summary-" + index} url={item.data} id={item.type}
                                    language={this.props.language} layoutColumns={this.props.layoutColumns}
                                    courseAttributes={{
                                        course_type: page.course_type,
                                        label_dipartimento: page.label_dipartimento,
                                        color_dipartimento: page.color_dipartimento
                                    }} />
                            </div>
                            : (item.type === 'contact_form') ?
                                <div>
                                    <C90ContactForm course={item.title} key={"left-item-contact_form" + index} language={this.props.language} layoutColumns={this.props.layoutColumns} />
                                </div>
                                :null
                );
        } else {
            return undefined;
        }
    }
}

export default CoursePageLeftContent;